/**
 * Коды прав хаба (IC-2972). Дублируют серверный enum
 * `BeOpenHub.Internal.Permissions.HubPermissionCode` — держать синхронно с ним.
 *
 * Исторически коды объявлялись инлайн в каждом компоненте; гранулярные права
 * меню/стоплистов (фаза D) используются во многих местах, поэтому вынесены сюда
 * как единый источник правды. Значения существующих прав менять нельзя — они
 * персистентны (БД role_permissions, JWT permission_code).
 */
export const PermissionCode = {
  OrganizationView: 1000001,
  OrganizationEdit: 1000002,

  UserView: 1000011,
  UserEdit: 1000012,
  UserSecureEdit: 1000014,

  RoleView: 1000021,
  RoleEdit: 1000022,
  RoleDelete: 1000023,

  ProductView: 1000031,
  ProductEdit: 1000032,

  MenuView: 1000041,
  MenuEdit: 1000042,
  MenuDelete: 1000043,

  /** Ручная выгрузка меню и стоплистов. */
  MenuUpload: 1000044,

  /** Просмотр истории выгрузок меню и стоплистов. */
  MenuUploadHistoryView: 1000045,

  /** Настройка расписания автоматических выгрузок меню и стоплистов. */
  MenuUploadScheduleEdit: 1000046,

  /** Ручное изменение публикации меню (кнопка published и обратно). */
  MenuPublicationToggle: 1000047,

  /** Скачивание файлов результата конвертации меню из истории. */
  MenuConversionFileDownload: 1000048,

  PipeView: 1000051,
  PipeEdit: 1000052,
  PipeDelete: 1000053,

  ConfigurationView: 1000061,
  ConfigurationEdit: 1000062,

  ReportView: 1000071,

  SpecialInstructionView: 1000081,
  SpecialInstructionEdit: 1000082,

  /** Просмотр заказов (список, мастер-лист, история, детали, статистика). */
  OrderView: 1000091,

  /** Ручное изменение статуса заказа. */
  OrderEdit: 1000092,

  /** Просмотр событий организации. */
  EventView: 1000093,

  /** Подтверждение события (передача в обработку). */
  EventConfirm: 1000094,

  // Promo (1000095-97) принадлежит GetPos (GetPosPermissionCode.GetPosPromo*), из блока хаба удалено.
} as const;

/**
 * Коды прав GetPos (IC-2972 phase E round 2/3). Дублируют серверный enum
 * `BeOpen.GeCo.Pos.Permissions.GetPosPermissionCode` — держать синхронно с ним.
 * Отдельный блок 2000000-2999999: пользователям GetPos права выдаёт сам GetPos,
 * а не хаб, поэтому пересечений с `PermissionCode` здесь быть не может.
 */
export const GetPosPermissionCode = {
  GetPosOrganizationView: 2000001,
  GetPosOrganizationEdit: 2000002,

  GetPosProductView: 2000011,
  GetPosProductEdit: 2000012,
  GetPosProductDelete: 2000013,

  GetPosMenuView: 2000021,
  GetPosMenuEdit: 2000022,
  GetPosMenuDelete: 2000023,

  GetPosMenuUploadHistoryView: 2000031,
  GetPosMenuUploadScheduleEdit: 2000032,
  GetPosMenuConversionFileDownload: 2000033,

  GetPosPromoView: 2000061,
  GetPosPromoEdit: 2000062,
  GetPosPromoDelete: 2000063,

  GetPosRoleView: 2000071,
  GetPosRoleEdit: 2000072,
} as const;
